












































































import { Component } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import OpportunitySourceDto from '@/models/Opportunities/OpportunitySourceDto'
import OpportunitySourceCreate from '@/components/OpportunitySources/OpportunitySourceCreate.vue';
import OpportunitySourceEdit from '@/components/OpportunitySources/OpportunitySourceEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'OpportunitySources',
  components: { OpportunitySourceCreate, OpportunitySourceEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentOpportunitySource(null);
    }

    async updateOpportunitySource(opportunitySource: OpportunitySourceDto) {
        AgencySettingsModule.updateCurrentOpportunitySource(opportunitySource);
    }

    get currentOpportunitySource() {
        return AgencySettingsModule.currentOpportunitySource;
    }

    get loadingOpportunitySources() {
        return AgencySettingsModule.loadingOpportunitySources;
    }

    get opportunitySources() {
        return AgencySettingsModule.opportunitySources;
    }

    async deleteOpportunitySource() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this Opportunity Source?', options);
        if (result) {
            AgencySettingsModule.deleteOpportunitySource(this.currentOpportunitySource);
        }
    }
}
